import styled from 'styled-components';

export const WrapperStyled = styled.div`
  && {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
`;
